/* CE Elevate — global interaction layer ("Brand Elevation").
   Visual/animation only: scroll reveals, hero stagger, decorative
   offer sticker, review count-up, two-tone wordmark. No commerce
   logic, no tracking, no copy changes. Idempotent; safe without JS
   (classes that hide content are only added when this runs) and in
   the theme editor (designMode skips the reveal gate entirely). */
(function () {
  if (window.__ceElevateInit) return;
  window.__ceElevateInit = true;

  var designMode = (window.Shopify && window.Shopify.designMode) ||
    document.documentElement.classList.contains('shopify-design-mode');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  if (!designMode) {
    document.documentElement.classList.add('ce-k-js'); /* keepsake-era reveal gate (home sections) */
    document.documentElement.classList.add('ce-e-js');
  }

  /* Sections whose headers/cards get the scroll reveal (existing markup,
     class assigned at runtime — unknown selectors simply no-op). */
  var REVEAL_TARGETS = [
    '.ce-proof__header',
    '.ce-protection__header', '.ce-protection__card',
    '.ce-hiw__header', '.ce-hiw__step',
    '.ce-lifestyle__header', '.ce-lifestyle__card',
    '.ce-noblur__content', '.ce-noblur__image-wrap', '.ce-noblur__image',
    '.ce-fiveordie__header', '.ce-fiveordie__card',
    '.ce-bogo__content', '.ce-bogo__inner',
    '.ce-social-proof__header', '.ce-social-proof__card',
    '.ce-product-faq__heading', '.ce-product-faq__list',
    '.ce-related-articles__header', '.ce-related-articles__card',
    '.ce-model-hub__title', '.ce-model-hub__brand',
    '.ce-founder__inner', '.ce-founder__content',
    '.ce-seo-content__inner'
  ];

  function initReveals() {
    if (designMode) return;
    var els = [];
    REVEAL_TARGETS.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          if (!el.classList.contains('e-reveal-auto')) { el.classList.add('e-reveal-auto'); }
        });
      } catch (e) { /* bad selector guard */ }
    });
    els = Array.prototype.slice.call(document.querySelectorAll('.e-reveal-auto, .k-reveal, .e-reveal'));
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -70px 0px', threshold: 0.06 });
    els.forEach(function (el) {
      /* anything already in the first viewport shows immediately */
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
        el.classList.add('is-in');
      } else {
        io.observe(el);
      }
    });
  }

  /* Hero entrance stagger: fade/rise the hero's top-level columns. */
  function initHeroStagger() {
    if (designMode || reduce) return;
    var parts = document.querySelectorAll(
      '.k-hero .k-hero__content, .k-hero .k-hero__media,' +
      '.ce-hero .ce-hero__content, .ce-hero .ce-hero__media'
    );
    Array.prototype.forEach.call(parts, function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity 0.9s ' + EASE + ', transform 0.9s ' + EASE;
      setTimeout(function () {
        el.style.opacity = '1';
        el.style.transform = 'none';
        /* clear inline transform so sticky/position logic is unaffected */
        setTimeout(function () { el.style.transform = ''; el.style.transition = ''; el.style.opacity = ''; }, 1000);
      }, 90 + i * 150);
    });
  }

  /* Decorative BOGO sticker on hero imagery. Echoes the sitewide
     offer already stated in the announcement bar — no new claims.
     Skipped when a host already carries one (idempotent). */
  var STICKER_HOSTS = [
    '.ce-hero .ce-hero__media',
    '.k-hero .k-hero__media'
  ];
  function injectSticker() {
    var host = null, inset = false;
    var caps = 'Buy 1<br>Get 1', script = 'Free';
    for (var i = 0; i < STICKER_HOSTS.length; i++) {
      var el = document.querySelector(STICKER_HOSTS[i]);
      if (el) { host = el; break; }
    }
    /* PDP gallery sticker, ON the photo (22/22 inset) — not straddling
       the container corner like the LP offer sticker. Case PDPs carry
       the lifetime-guarantee sticker (spec); non-case PDPs (the
       combined/individual selector modes) get the BOGO sticker — the
       offer applies sitewide, the guarantee claim is cases-only. */
    if (!host) {
      var pdpHero = document.querySelector('.ce-product-hero');
      if (pdpHero) {
        var nonCasePdp = pdpHero.querySelector('.ce-product-hero__combined-selector') ||
                         pdpHero.querySelector('.ce-product-hero__individual-selector');
        host = pdpHero.querySelector('.ce-product-hero__image-wrap');
        inset = true;
        if (!nonCasePdp) {
          caps = 'Lifetime';
          script = 'guarantee';
        }
      }
    }
    if (!host || host.querySelector('.e-sticker')) return;
    /* No-BOGO surfaces (data-ce-no-bogo, stamped by the hero sections from
       ce_rebrand.bogo_enabled = false): the offer sticker would advertise a
       deal the product cannot honor (the rug family is single-unit only),
       and the guarantee sticker is a cases-only claim. Skip both. */
    if (host.closest('[data-ce-no-bogo]')) return;
    var cs = window.getComputedStyle(host);
    if (cs.position === 'static') { host.style.position = 'relative'; }
    var s = document.createElement('div');
    s.className = 'e-sticker e-sticker--pop';
    s.setAttribute('aria-hidden', 'true');
    s.innerHTML =
      '<span class="e-sticker__caps">' + caps + '</span>' +
      '<span class="e-sticker__script">' + script +
      '<svg viewBox="0 0 60 8" aria-hidden="true"><path d="M2 5.5 C 16 2.5, 32 2, 58 4.5" fill="none" stroke="#1E2529" stroke-width="2" stroke-linecap="round"></path></svg>' +
      '</span>';
    if (script.length > 6) { s.classList.add('e-sticker--long'); }
    s.style.top = inset ? '22px' : '-18px';
    s.style.left = inset ? '22px' : '-14px';
    host.appendChild(s);
    if (designMode || reduce) {
      s.classList.add('is-popped');
    } else {
      setTimeout(function () { s.classList.add('is-popped'); }, 700);
    }
  }

  /* Review count-up: finds the review-count number in the hero rating
     line and counts it up once (1.4s, ease-out, no layout shift). */
  function initCountUp() {
    if (designMode || reduce) return;
    var scope = document.querySelector('.ce-hero__badge, .ce-hero__rating, .ce-product-hero__rating');
    if (!scope || scope.__ceCounted) return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var node = null, match = null;
    while ((node = walker.nextNode())) {
      var m = node.nodeValue && node.nodeValue.match(/(\d{1,3}(?:,\d{3})+|\d{4,})/);
      if (m) { match = { node: node, num: m[1] }; break; }
    }
    if (!match) return;
    scope.__ceCounted = true;
    var target = parseInt(match.num.replace(/,/g, ''), 10);
    if (!target || target < 100) return;
    var span = document.createElement('span');
    span.style.fontVariantNumeric = 'tabular-nums';
    var parts = match.node.nodeValue.split(match.num);
    var after = document.createTextNode(parts.slice(1).join(match.num));
    var before = document.createTextNode(parts[0]);
    var parent = match.node.parentNode;
    parent.replaceChild(after, match.node);
    parent.insertBefore(span, after);
    parent.insertBefore(before, span);
    /* reserve width to avoid layout shift */
    span.textContent = match.num;
    var w = span.getBoundingClientRect().width;
    if (w) { span.style.display = 'inline-block'; span.style.minWidth = Math.ceil(w) + 'px'; }
    var t0 = null, DUR = 1400;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / DUR);
      var eased = 1 - Math.pow(1 - p, 3);
      span.textContent = Math.round(target * eased).toLocaleString('en-US');
      if (p < 1) { requestAnimationFrame(step); }
    }
    requestAnimationFrame(step);
  }

  /* Accent-word system: the design language closes every major heading
     with an Instrument Serif italic coral word. Wrap the LAST word of
     each listed heading (plus trailing punctuation) in a span — pure
     presentation of existing copy, idempotent, designMode-safe. */
  var ACCENT_HEADINGS = [
    '.k-coll__h2', '.k-craft__h2', '.k-steps__h2', '.k-gift__h2',
    '.k-words__head .k-eyebrow',
    '.ce-protection__title', '.ce-hiw__title', '.ce-fiveordie__title',
    '.ce-lifestyle__title', '.ce-noblur__title', '.ce-bogo__title',
    '.ce-product-faq__heading', '.ce-reviews__title',
    '.ce-seo-content__heading', '.ce-model-hub__title',
    '.ce-related-articles__title'
  ];
  function lastTextNode(el) {
    for (var i = el.childNodes.length - 1; i >= 0; i--) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && /\S/.test(n.nodeValue)) return n;
      if (n.nodeType === 1 && !n.classList.contains('e-accent')) {
        var deep = lastTextNode(n);
        if (deep) return deep;
      }
    }
    return null;
  }
  function initAccents() {
    ACCENT_HEADINGS.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (h) {
          if (h.querySelector('.e-accent') || h.querySelector('em')) return;
          var node = lastTextNode(h);
          if (!node) return;
          var m = node.nodeValue.match(/^(.*?)(\S+)(\s*)$/);
          if (!m || !m[2]) return;
          var word = m[2];
          if (word.replace(/[^\w]/g, '').length < 3) return; /* skip tiny fragments */
          var span = document.createElement('span');
          span.className = 'e-accent';
          span.textContent = word;
          var tail = document.createTextNode(m[3] || '');
          node.nodeValue = m[1];
          var parent = node.parentNode;
          var next = node.nextSibling;
          parent.insertBefore(span, next);
          parent.insertBefore(tail, next);
        });
      } catch (e) { /* selector guard */ }
    });
    /* pull trailing punctuation into existing emphasis spans (design colors the period) */
    document.querySelectorAll('.k-hero__h1 em, .k-final__h2 em, .k-gift__h2 em').forEach(function (em) {
      var sib = em.nextSibling;
      if (sib && sib.nodeType === 3) {
        var pm = sib.nodeValue.match(/^([.!?…]+)/);
        if (pm) {
          em.textContent += pm[1];
          sib.nodeValue = sib.nodeValue.slice(pm[1].length);
        }
      }
    });
    /* announcement bar: italicize the trailing clause per the type-pairing language */
    document.querySelectorAll('.announcement-bar__message').forEach(function (msg) {
      if (msg.querySelector('.e-accent-tail')) return;
      var node = lastTextNode(msg);
      if (!node) return;
      var mm = node.nodeValue.match(/^(.*\S)\s+(\S+\s+\S+)\s*$/);
      if (!mm) return;
      var tailSpan = document.createElement('span');
      tailSpan.className = 'e-accent-tail';
      tailSpan.textContent = mm[2];
      node.nodeValue = mm[1] + ' ';
      node.parentNode.insertBefore(tailSpan, node.nextSibling);
    });
    /* Founder quotes: the design accents the emotional peak — the order
       count mid-quote, or the closing phrase (existing copy, styled only) */
    document.querySelectorAll('.ce-founder__quote, .k-founder__quote').forEach(function (q) {
      if (q.querySelector('.e-accent')) return;
      var walker = document.createTreeWalker(q, NodeFilter.SHOW_TEXT, null);
      var node, hit = null;
      while ((node = walker.nextNode())) {
        var m = node.nodeValue.match(/([\d,]{4,}\+?\s+(?:orders|cases))/i);
        if (m) { hit = { node: node, phrase: m[1] }; break; }
      }
      if (hit) {
        var parts = hit.node.nodeValue.split(hit.phrase);
        var span = document.createElement('span');
        span.className = 'e-accent';
        span.textContent = hit.phrase;
        var afterText = document.createTextNode(parts.slice(1).join(hit.phrase));
        var beforeText = document.createTextNode(parts[0]);
        var par = hit.node.parentNode;
        par.replaceChild(afterText, hit.node);
        par.insertBefore(span, afterText);
        par.insertBefore(beforeText, span);
        return;
      }
      /* no count present — accent the closing phrase (last four words) */
      var tail = lastTextNode(q);
      if (!tail) return;
      var tm = tail.nodeValue.match(/^([\s\S]*?)((?:\S+\s+){3}\S+\s*)$/);
      if (!tm) return;
      var span2 = document.createElement('span');
      span2.className = 'e-accent';
      span2.textContent = tm[2].replace(/\s+$/, '');
      tail.nodeValue = tm[1];
      tail.parentNode.appendChild(span2);
    });
    /* How-it-works numerals: index via data attribute (CSS renders "N.") */
    document.querySelectorAll('.ce-hiw__steps').forEach(function (wrap) {
      var i = 0;
      wrap.querySelectorAll('.ce-hiw__step').forEach(function (s) {
        i += 1;
        if (!s.hasAttribute('data-e-num')) s.setAttribute('data-e-num', String(i));
      });
    });
    initStepNums();
  }

  /* PDP step labels: serif-italic coral numeral ("1. Select Your Phone").
     The selector machinery renders these client-side after data load, so
     this runs at init, on short retries, and on the machinery's own
     state-change event (idempotent via the class guard). */
  function initStepNums() {
    document.querySelectorAll('.ce-product-hero__step-label, .ce-product-hero__step-number').forEach(function (label) {
      if (label.querySelector('.e-step-num')) return;
      var node = label.firstChild;
      /* skip leading whitespace-only nodes */
      while (node && node.nodeType === 3 && !/\S/.test(node.nodeValue)) node = node.nextSibling;
      if (!node) return;
      if (node.nodeType === 1) {
        /* numeral already lives in its own element — just adopt it */
        if (/^\s*\d+[.:]?\s*$/.test(node.textContent)) node.classList.add('e-step-num');
        return;
      }
      var nm = node.nodeValue.match(/^(\s*\d+[.:]?)(\s*)/);
      if (!nm) return;
      var span = document.createElement('span');
      span.className = 'e-step-num';
      span.textContent = nm[1].trim();
      node.nodeValue = node.nodeValue.slice(nm[0].length);
      label.insertBefore(document.createTextNode(' '), node);
      label.insertBefore(span, label.firstChild);
    });
  }

  function initCtaPriceSuffix() {
    /* hero CTA price suffix ("… → From $24.99") gets the italic-serif voice */
    document.querySelectorAll('.ce-hero__cta').forEach(function (cta) {
      if (cta.querySelector('.e-cta-price')) return;
      var node = lastTextNode(cta);
      if (!node) return;
      var pm = node.nodeValue.match(/^([\s\S]*?)(From\s+\$[\d.,]+\s*)$/i);
      if (!pm) return;
      var span = document.createElement('span');
      span.className = 'e-cta-price';
      span.textContent = pm[2].trim();
      node.nodeValue = pm[1];
      node.parentNode.insertBefore(span, node.nextSibling);
    });
  }

  /* LP sticky pill: price + promo + button share one row. On narrow
     screens the row can run out of room (long model CTAs like "Design
     My Pro Max Case") — degrade by dropping the promo first, then the
     price line, so the button never truncates or leaves the pill.
     Measured, not guessed: runs after fonts settle and again on resize. */
  function initStickyPromoGuard() {
    var run = function () {
      document.querySelectorAll('.ce-sticky').forEach(function (card) {
        var info = card.querySelector('.ce-sticky__info');
        var promo = card.querySelector('.ce-sticky__promo');
        if (!info) return;
        card.classList.remove('e-promo-tight');
        card.classList.remove('e-title-tight');
        /* the promo flexes down first — any truncation means an ugly
           "★ 4.…" sliver, so it goes entirely */
        if (promo && promo.scrollWidth - promo.clientWidth > 4) {
          card.classList.add('e-promo-tight');
        }
        /* the title never flexes; if it still overflows the info box
           (long model CTAs on narrow screens), it goes too */
        if (info.scrollWidth - info.clientWidth > 4) {
          card.classList.add('e-title-tight');
        }
      });
    };
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(run, 150);
    });
  }

  /* Proof-gallery photo cycle: the spec trades one grid tile's photo for
     a pooled one every few seconds (fade out → swap → fade in). The pool
     is every photo the section renders but the desktop grid hides — the
     grid shows the first ten and the track also carries marquee clones,
     so the pool is deduped by URL. Displayed photos and the waiting queue
     stay disjoint by construction: a swapped-out photo goes to the back
     of the queue, so the same photo can never sit in two tiles at once.
     Ticks are gated on the ≥900px grid — the mobile strip keeps the
     marquee and never swaps. */
  function initProofCycle() {
    if (designMode || reduce || !window.matchMedia) return;
    var GRID = 10, PERIOD = 3500, FADE = 550;
    var mq = window.matchMedia('(min-width: 900px)');
    document.querySelectorAll('.ce-proof__track').forEach(function (track) {
      if (track.__ceCycle) return;
      var wraps = track.querySelectorAll('.ce-proof__photo');
      if (wraps.length <= GRID) return;
      function attrsOf(img) {
        return {
          src: img.getAttribute('src') || '',
          srcset: img.getAttribute('srcset') || '',
          sizes: img.getAttribute('sizes') || '',
          alt: img.getAttribute('alt') || ''
        };
      }
      var tiles = [], displayed = {}, queue = [];
      for (var i = 0; i < GRID; i++) {
        var img = wraps[i].querySelector('img');
        if (!img || !img.getAttribute('src')) return;
        tiles.push(img);
        displayed[img.getAttribute('src')] = true;
      }
      for (var j = GRID; j < wraps.length; j++) {
        var cand = wraps[j].querySelector('img');
        if (!cand) continue;
        var key = cand.getAttribute('src');
        if (!key || displayed[key]) continue;
        var queued = false;
        for (var q = 0; q < queue.length; q++) {
          if (queue[q].src === key) { queued = true; break; }
        }
        if (!queued) queue.push(attrsOf(cand));
      }
      if (!queue.length) return;
      track.__ceCycle = true;
      var ti = 0, busy = false;
      setInterval(function () {
        if (busy || document.hidden || !mq.matches) return;
        busy = true;
        var tile = tiles[ti % tiles.length];
        ti++;
        var next = queue.shift();
        var pre = new Image();
        pre.onload = function () {
          tile.style.transition = 'opacity 0.55s ease';
          tile.style.opacity = '0';
          setTimeout(function () {
            queue.push(attrsOf(tile));
            if (next.srcset) { tile.setAttribute('srcset', next.srcset); } else { tile.removeAttribute('srcset'); }
            if (next.sizes) { tile.setAttribute('sizes', next.sizes); } else { tile.removeAttribute('sizes'); }
            tile.setAttribute('alt', next.alt);
            tile.setAttribute('src', next.src);
            setTimeout(function () { tile.style.opacity = '1'; busy = false; }, 120);
          }, FADE);
        };
        pre.onerror = function () { queue.push(next); busy = false; };
        if (next.srcset) { pre.srcset = next.srcset; }
        if (next.sizes) { pre.sizes = next.sizes; }
        pre.src = next.src;
      }, PERIOD);
    });
  }

  /* Buy-box protection selector. Chips carry only what varies — photo,
     name, price, the 2nd-case offer, and the drop rating as a pill riding
     on the photo (zero row height). The four USP rows that used to repeat
     on every chip are gone: 18 of those 24 cells were the same string, so
     they cost height and taught nothing. The shared detail now lives in one
     rail under the row that rewrites itself for the selected tier —
     selecting IS the disclosure, so details cost no extra tap.

     MagSafe is PER-TIER and never shared. Basic and Protective genuinely
     have none, so the old shared "Premium MagSafe" row asserted something
     false about them. Elite and Ultimate BOTH have it at $45/10 ft, so
     MagSafe can't separate those two either — the drop rating is the only
     fact that both varies and is true across the ladder, which is exactly
     what the pill carries and nothing else.

     Keyed on DISPLAY name (templates' display_name wins). Cards are
     client-rendered by the frozen machinery — decorate after render,
     idempotent, re-applied on ce:state-change. */
  var TIER_SPEC = {
    'Elite + MagSafe':      { drop: '10 ft drop', rows: [['drop', '10 ft drop-tested'], ['rugged', 'TPU shock absorption'], ['magsafe', 'Built-in MagSafe'], ['print', 'Glossy HD Print']] },
    'Ultimate + MagSafe':   { drop: '10 ft drop', rows: [['drop', '10 ft drop-tested'], ['rugged', 'TPU + TPE shock absorption'], ['magsafe', 'Built-in MagSafe'], ['print', 'Glossy HD Print']] },
    'Protective + MagSafe': { drop: '7 ft drop',  rows: [['drop', '7 ft drop-tested'], ['rugged', 'Dual-layer TPU + hard shell'], ['magsafe', 'Built-in MagSafe'], ['print', 'Glossy HD Print']] },
    'Protective':           { drop: '7 ft drop',  rows: [['drop', '7 ft drop-tested'], ['rugged', 'Dual-layer TPU + hard shell'], ['guarantee', 'Lifetime warranty included'], ['print', 'Glossy HD Print']] },
    'Basic':                { drop: '3 ft drop',  rows: [['drop', '3 ft drop-tested'], ['rugged', 'Slim one-piece TPU'], ['guarantee', 'Lifetime warranty included'], ['print', 'Glossy HD Print']] },
    'Elite Ultra + MagSafe':{ drop: '25 ft drop', rows: [['drop', '25 ft drop-tested'], ['rugged', 'Air-pocket corners'], ['magsafe', 'Built-in MagSafe'], ['print', 'Glossy HD Print']] }
  };

  /* PDP FREE-first pricing (CRO adjudication of the merchant's call):
     prices stay single ("$50" — a clean, spread-out tier ladder), and
     the offer rides as a co-fixated "2nd Case FREE" line in the price
     lockup — FREE does the work "2 for $50" surrendered, with no
     arithmetic path to an imagined $25 single. The under-CTA line
     carries the mechanic + the applied-automatically reassurance.
     Case PDPs only — BOGO is a cases-only claim, and the
     combined/individual selector modes mark non-case products. All
     rewrites are idempotent and re-applied on ce:state-change. */
  function decorateFreePricing() {
    var hero = document.querySelector('.ce-product-hero');
    if (!hero ||
        hero.querySelector('.ce-product-hero__combined-selector') ||
        hero.querySelector('.ce-product-hero__individual-selector')) return;
    /* No-BOGO products (data-ce-no-bogo from ce_rebrand.bogo_enabled =
       false) must never take the FREE-first case pricing, even when the
       selector-mode heuristic reads the PDP as a case (e.g. the AirPods
       Max shell case: single variant, no selector, no BOGO offer). Same
       guard as the offer sticker. */
    if (hero.closest('[data-ce-no-bogo]') || hero.querySelector('[data-ce-no-bogo]')) return;
    hero.querySelectorAll('.ce-product-hero__tier-card-price').forEach(function (el) {
      if (el.nextElementSibling && el.nextElementSibling.classList.contains('e-tier-offer')) return;
      var offer = document.createElement('div');
      offer.className = 'e-tier-offer';
      offer.appendChild(document.createTextNode('2nd Case '));
      var free = document.createElement('b');
      free.className = 'e-tier-offer__free';
      /* the sticker's hand-drawn squiggle, coral — same brand stroke,
         quiet emphasis under the one word doing the work */
      free.innerHTML = 'FREE<svg viewBox="0 0 60 8" aria-hidden="true"><path d="M2 5.5 C 16 2.5, 32 2, 58 4.5" fill="none" stroke="#123F37" stroke-width="2.5" stroke-linecap="round"></path></svg>';
      offer.appendChild(free);
      el.parentNode.insertBefore(offer, el.nextSibling);
    });
    hero.querySelectorAll('[id^="ce-product-hero__cta-"]').forEach(function (btn) {
      var t = btn.textContent;
      if (t.indexOf('·') === -1 && /\s\$[\d.]+\s*$/.test(t)) {
        btn.textContent = t.replace(/\s(\$[\d.]+)(\s*)$/, ' · $1$2');
      }
    });
    hero.querySelectorAll('.ce-product-hero__sub-cta').forEach(function (el) {
      if (el.__ceRewritten) return;
      el.__ceRewritten = true;
      for (var n = el.lastChild, prev; n; n = prev) {
        prev = n.previousSibling;
        if (n.nodeType === 3) { el.removeChild(n); }
      }
      el.appendChild(document.createTextNode(' 2nd Case Free — Applied Automatically'));
    });
    /* Challenger: the finish step is retired — everything ships glossy
       (the skin hides the step; the machinery's own auto-select already
       lands on finishes[0], which the alphabetical sort makes glossy).
       This guard makes the intent explicit: if a finish card ever
       renders un-selected on glossy, click it through the machinery's
       own path so state/variant/events stay canonical. */
    var glossyCard = hero.querySelector('.ce-product-hero__finish-card[data-finish="glossy"]:not(.active)');
    if (glossyCard) { glossyCard.click(); }
  }

  /* Non-case PDPs (blankets, desk mats — the combined/individual
     selector modes mark them). What happens here:
     - the under-CTA line drops the hardcoded "Lifetime Guarantee"
       (cases-only claim) for the case-style single line
     - option-card offer chips become the case price lockup: "2nd
       Blanket FREE" with the hand-drawn coral squiggle under FREE
     - the CTA price join matches cases ("· $60", not "→ $60")
     - desk-mat size cards restructure into the case tier-card shape
       (name / size / exact price / "2nd Desk Mat FREE" / per-size
       feature bullets); the BOGO banner above the CTA is gone (Matt +
       CRO: the card FREE lines + sub-CTA line carry the offer)
     - blanket size cards take the same tier-card shape (size /
       use-case line / exact price for the chosen material / "2nd
       Blanket FREE"), plus the template's MOST POPULAR badge — the
       machinery's plain-card renderer drops valCfg.badge on the floor
     - the LAST option's cards get a price placeholder from first
       render, so the machinery's downstream re-render (which adds
       .ce-oc-price after a prior option is picked) can't grow the
       card and shift the page */
  var SQUIGGLE = '<svg viewBox="0 0 60 8" aria-hidden="true"><path d="M2 5.5 C 16 2.5, 32 2, 58 4.5" fill="none" stroke="#123F37" stroke-width="2.5" stroke-linecap="round"></path></svg>';
  /* Product-family noun for non-case PDPs — mirrors
     snippets/ce-product-noun.liquid. '' = case (or unrecognized):
     leave the case copy alone. 'case' wins over every other match so
     a case product name can never fall into another family. */
  var NONCASE_NOUNS = [
    ['cutting board', /cutting\s*board/i],
    ['desk mat', /desk\s*mat/i], ['blanket', /blanket/i], ['tumbler', /tumbler/i],
    ['mug', /mug/i], ['candle', /candle/i], ['journal', /journal/i],
    ['notebook', /notebook/i], ['clock', /clock/i], ['towel', /towel/i],
    ['puzzle', /puzzle/i], ['canvas print', /canvas/i], ['poster', /poster/i],
    ['watch band', /watch\s*band/i], ['ornament', /ornament/i], ['magnet', /magnet/i],
    ['hoodie', /hoodie/i], ['sweatshirt', /sweatshirt/i], ['shirt', /shirt/i],
    /* Word-bounded so a title like "Rugged Case" can never land here even
       without the /case/i gate above it. Covers "Rug" and "Rugs". */
    ['rug', /\brugs?\b/i]
  ];
  function nonCaseNoun(title) {
    /* Deliberate exceptions ABOVE the /case/i gate: the AirPods Max shell
       case, the Kindle case and the MacBook case are case nouns whose PDPs
       must not take phone-case copy (no BOGO offer, different claims).
       Mirrors ce-product-noun.liquid. */
    if (/airpods\s*max/i.test(title)) return 'airpods max case';
    if (/kindle/i.test(title)) return 'kindle case';
    if (/macbook/i.test(title)) return 'macbook case';
    if (/case/i.test(title)) return '';
    for (var i = 0; i < NONCASE_NOUNS.length; i++) {
      if (NONCASE_NOUNS[i][1].test(title)) return NONCASE_NOUNS[i][0];
    }
    return '';
  }
  function titleCaseNoun(noun) {
    return noun.replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
  }
  var DESKMAT_FEATURES = {
    XXL: [['print', 'HD Print'], ['neoprene', '3mm Comfort Neoprene'], ['antislip', 'Anti-Slip Back'], ['sewn', 'Sewn & Printed Edges']],
    XL:  [['print', 'HD Print'], ['neoprene', '3mm Comfort Neoprene'], ['antislip', 'Anti-Slip Back'], ['sewn', 'Sewn Black Edge']],
    L:   [['print', 'HD Print'], ['neoprene', '3mm Comfort Neoprene'], ['antislip', 'Anti-Slip Back'], ['sewn', 'Sewn & Printed Edge']],
    M:   [['print', 'HD Print'], ['neoprene', '3mm Comfort Neoprene'], ['antislip', 'Anti-Slip Back'], ['sewn', 'Sewn Black Edge']],
    S:   [['print', 'HD Print'], ['sewn', 'Sewn Edge'], ['sewn', 'Black Edging']]
  };
  var BLANKET_SIZE_BADGES = { '60" x 80"': 'MOST POPULAR' };
  /* Cutting-board feature rail rows, keyed by the SHAPE option value —
     facts only (tempered glass / dye-sub print / rubber feet / policy);
     no knife, food-safety, heat, or durability claims. */
  var BOARD_FEATURES = {
    'Rectangle': [['rugged', 'Tempered Glass Build'], ['print', 'Vivid HD Photo Print'], ['antislip', 'Anti-Slip Rubber Feet'], ['guarantee', '30-Day Money-Back Guarantee']],
    'Wine Bottle': [['rugged', 'Tempered Glass Build'], ['print', 'Vivid HD Photo Print'], ['neoprene', 'Whorled Glass Texture'], ['guarantee', '30-Day Money-Back Guarantee']],
    'Round': [['rugged', 'Tempered Glass Build'], ['print', 'Vivid HD Photo Print'], ['antislip', 'Anti-Slip Rubber Feet'], ['guarantee', '30-Day Money-Back Guarantee']]
  };
  /* Rug feature rail rows, keyed by the STYLE option value — facts from the
     approved copy spec only (polyester chenille face, hemmed edges, style-
     specific backing, remake-on-defect); no durability, washability, or
     delivery claims. */
  var RUG_FEATURES = {
    'Area Rug': [['print', 'Vivid HD Photo Print'], ['neoprene', 'Polyester Chenille Face'], ['sewn', 'Hemmed Edges'], ['guarantee', 'Arrives Wrong? We Remake It']],
    'Outdoor Rug': [['print', 'Vivid HD Photo Print'], ['antislip', 'No-Skid Backing'], ['sewn', 'Hemmed Edges'], ['rugged', 'Made For Outdoor Use']],
    'Round Rug': [['print', 'Vivid HD Photo Print'], ['neoprene', 'Textured Face'], ['sewn', 'Hemmed Edges'], ['guarantee', 'Arrives Wrong? We Remake It']]
  };
  /* variant_display metafield, inlined by the section as the hero-config
     JSON — the machinery consumes badge/desc from it; the skin reads
     default/name for the mat rail. Fail-soft: a parse problem just means
     fallback copy, never a broken selector. */
  function matVariantDisplay(hero) {
    if (hero.__ceVD !== undefined) return hero.__ceVD;
    hero.__ceVD = null;
    var sect = hero.closest('[id^="shopify-section-"]') || document;
    var tag = sect.querySelector('script[id^="ce-hero-config-"]');
    if (tag) {
      try { hero.__ceVD = (JSON.parse(tag.textContent) || {}).variantDisplay || null; }
      catch (e) { /* stay null */ }
    }
    return hero.__ceVD;
  }
  /* One rail per mat selector, inserted AFTER the individual-selector
     (the machinery only ever renders INTO that container, so the rail is
     never wiped). Same e-tier-rail classes as the case rail — the skin
     CSS is shared. */
  function initMatRail(hero, matSel, matCards) {
    var active = matSel.querySelector('.ce-product-hero__visual-card.is-selected');
    /* before the default click lands, populate from the badged card so
       the rail never renders empty or shifts */
    for (var i = 0; i < matCards.length && !active; i++) {
      if (matCards[i].querySelector('.ce-product-hero__vc-badge')) active = matCards[i];
    }
    if (!active) active = matCards[0];
    var val = active.getAttribute('data-value') || '';
    var sm = val.match(/^\s*(XXL|XL|L|M|S)\b/);
    var letter = sm && sm[1];
    if (!letter || !DESKMAT_FEATURES[letter]) return;

    var rail = matSel.nextElementSibling;
    if (!rail || !rail.classList.contains('e-tier-rail')) {
      rail = document.createElement('div');
      rail.className = 'e-tier-rail';
      rail.setAttribute('aria-live', 'polite');
      rail.setAttribute('aria-atomic', 'true');
      matSel.insertAdjacentElement('afterend', rail);
    }
    /* the retry ladder + every state change call this; without the guard
       the rail would re-animate on each no-op pass */
    if (rail.__ceTier === val) return;
    rail.__ceTier = val;

    var vd = matVariantDisplay(hero);
    var vCfg = (vd && vd.option1 && vd.option1.values && vd.option1.values[val]) || {};
    var dims = vCfg.desc || (val.match(/\(([^)]+)\)/) || [])[1] || '';
    var headText = (vCfg.name || letter) + (dims ? ' — ' + dims : '');

    var base = elevateAssetBase();
    rail.innerHTML = '';
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = headText + ' includes';
    rail.appendChild(sr);

    var head = document.createElement('div');
    head.className = 'e-tier-rail__head';
    var nm = document.createElement('span');
    nm.className = 'e-tier-rail__name';
    nm.textContent = headText;
    head.appendChild(nm);
    var spectrum = document.querySelector('.ce-protection');
    if (spectrum) {
      var cmp = document.createElement('button');
      cmp.type = 'button';
      cmp.className = 'e-tier-rail__compare';
      cmp.textContent = 'Compare all sizes →';
      cmp.addEventListener('click', function () {
        spectrum.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      head.appendChild(cmp);
    }
    rail.appendChild(head);

    var ul = document.createElement('ul');
    ul.className = 'e-tier-rail__items';
    DESKMAT_FEATURES[letter].forEach(function (row, ri) {
      var li = document.createElement('li');
      li.style.setProperty('--e-rail-i', ri);
      var icon = document.createElement('img');
      icon.className = 'e-tier-rail__icon';
      icon.src = base + 'icon-usp-' + row[0] + '.png';
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      icon.width = 12;
      icon.height = 12;
      icon.loading = 'lazy';
      li.appendChild(icon);
      var label = document.createElement('span');
      label.className = 'e-tier-rail__label';
      label.textContent = row[1];
      li.appendChild(label);
      ul.appendChild(li);
    });
    rail.appendChild(ul);

    /* animate in only — fading out first would cost a round-trip and
       read as lag on tap */
    rail.classList.remove('is-in');
    requestAnimationFrame(function () { rail.classList.add('is-in'); });
  }
  /* Cutting-board rail — same e-tier-rail chrome as the mat rail, but
     keyed by the full SIZE option value (board sizes have no XXL-style
     letter prefix). One rail under the size cards, rewritten per
     selection; the compare link is omitted until a compare target
     section exists on the board PDP. */
  function initBoardRail(hero, boardSel, boardCards) {
    var active = boardSel.querySelector('.ce-product-hero__visual-card.is-selected') || boardCards[0];
    if (!active) return;
    var val = active.getAttribute('data-value') || '';
    if (!BOARD_FEATURES[val]) return;

    var rail = boardSel.nextElementSibling;
    if (!rail || !rail.classList.contains('e-tier-rail')) {
      rail = document.createElement('div');
      rail.className = 'e-tier-rail';
      rail.setAttribute('aria-live', 'polite');
      rail.setAttribute('aria-atomic', 'true');
      boardSel.insertAdjacentElement('afterend', rail);
    }
    if (rail.__ceTier === val) return;
    rail.__ceTier = val;

    var vd = matVariantDisplay(hero);
    var vCfg = (vd && vd.option1 && vd.option1.values && vd.option1.values[val]) || {};
    var headText = (vCfg.name || val) + (vCfg.desc ? ' — ' + vCfg.desc : '');

    var base = elevateAssetBase();
    rail.innerHTML = '';
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = headText + ' includes';
    rail.appendChild(sr);

    var head = document.createElement('div');
    head.className = 'e-tier-rail__head';
    var nm = document.createElement('span');
    nm.className = 'e-tier-rail__name';
    nm.textContent = headText;
    head.appendChild(nm);
    rail.appendChild(head);

    var ul = document.createElement('ul');
    ul.className = 'e-tier-rail__items';
    BOARD_FEATURES[val].forEach(function (row, ri) {
      var li = document.createElement('li');
      li.style.setProperty('--e-rail-i', ri);
      var icon = document.createElement('img');
      icon.className = 'e-tier-rail__icon';
      icon.src = base + 'icon-usp-' + row[0] + '.png';
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      icon.width = 12;
      icon.height = 12;
      icon.loading = 'lazy';
      li.appendChild(icon);
      var label = document.createElement('span');
      label.className = 'e-tier-rail__label';
      label.textContent = row[1];
      li.appendChild(label);
      ul.appendChild(li);
    });
    rail.appendChild(ul);

    rail.classList.remove('is-in');
    requestAnimationFrame(function () { rail.classList.add('is-in'); });
  }
  /* Individual-mode PDPs inline their product server-side, so the
     decorator has no global to read variant prices from. Fetch the
     same /products/<handle>.js the case machinery uses (one tiny
     request, non-case PDPs only) and re-decorate when it lands. */
  var NONCASE_PRODUCT = { requested: false, data: null };
  function fetchNonCaseProduct() {
    if (NONCASE_PRODUCT.requested) return;
    /* canonical first — preview/proxy URLs don't always carry the
       /products/<handle> path */
    var canonical = document.querySelector('link[rel="canonical"]');
    var m = ((canonical && canonical.href) || location.pathname).match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    NONCASE_PRODUCT.requested = true;
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { NONCASE_PRODUCT.data = p; decorateNonCaseOffer(); })
      .catch(function () { /* cards keep their reserved price slots */ });
  }
  /* Rug rail — same e-tier-rail chrome, keyed by the full STYLE option value
     (RUG_FEATURES). The compare link targets the size spectrum section the
     launch-rug template carries ("Which size is right for you?"). */
  function initRugRail(hero, rugSel, rugCards) {
    var active = rugSel.querySelector('.ce-product-hero__visual-card.is-selected') || rugCards[0];
    if (!active) return;
    var val = active.getAttribute('data-value') || '';
    if (!RUG_FEATURES[val]) return;

    var rail = rugSel.nextElementSibling;
    if (!rail || !rail.classList.contains('e-tier-rail')) {
      rail = document.createElement('div');
      rail.className = 'e-tier-rail';
      rail.setAttribute('aria-live', 'polite');
      rail.setAttribute('aria-atomic', 'true');
      rugSel.insertAdjacentElement('afterend', rail);
    }
    if (rail.__ceTier === val) return;
    rail.__ceTier = val;

    var vd = matVariantDisplay(hero);
    var vCfg = (vd && vd.option1 && vd.option1.values && vd.option1.values[val]) || {};
    var headText = (vCfg.name || val) + (vCfg.desc ? ' — ' + vCfg.desc : '');

    var base = elevateAssetBase();
    rail.innerHTML = '';
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = headText + ' includes';
    rail.appendChild(sr);

    var head = document.createElement('div');
    head.className = 'e-tier-rail__head';
    var nm = document.createElement('span');
    nm.className = 'e-tier-rail__name';
    nm.textContent = headText;
    head.appendChild(nm);
    var spectrum = document.querySelector('.ce-protection');
    if (spectrum) {
      var cmp = document.createElement('button');
      cmp.type = 'button';
      cmp.className = 'e-tier-rail__compare';
      cmp.textContent = 'Compare all sizes →';
      cmp.addEventListener('click', function () {
        spectrum.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      head.appendChild(cmp);
    }
    rail.appendChild(head);

    var ul = document.createElement('ul');
    ul.className = 'e-tier-rail__items';
    RUG_FEATURES[val].forEach(function (row, ri) {
      var li = document.createElement('li');
      li.style.setProperty('--e-rail-i', ri);
      var icon = document.createElement('img');
      icon.className = 'e-tier-rail__icon';
      icon.src = base + 'icon-usp-' + row[0] + '.png';
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      icon.width = 12;
      icon.height = 12;
      icon.loading = 'lazy';
      li.appendChild(icon);
      var label = document.createElement('span');
      label.className = 'e-tier-rail__label';
      label.textContent = row[1];
      li.appendChild(label);
      ul.appendChild(li);
    });
    rail.appendChild(ul);

    rail.classList.remove('is-in');
    requestAnimationFrame(function () { rail.classList.add('is-in'); });
  }
  /* Airpods max case features (facts only: sublimation print, polycarbonate
     shell, made-right guarantee — no drop/impact or delivery claims). */
  var AIRPODS_FEATURES = {
    'Custom': [['print', 'Vivid Full-Wrap Sublimation Print'], ['rugged', 'Lightweight Polycarbonate Shell'], ['guarantee', 'Scratch Protection Built In']]
  };
  /* Kindle case features (facts only, from the fulfilling vendor's catalog:
     UV-printed Saffiano leatherette across all three models, plus the folio
     family's TPU cradle and magnetic sleep/wake lid — no drop/impact or
     delivery claims). Keyed 'default' so the SAME rail serves every model
     card: the 2026-07-28 option-value rename to model names silently killed
     a value-keyed lookup ('Custom') and the rail vanished — never key rails
     to renameable option values again. */
  var KINDLE_FEATURES = {
    'default': [['print', 'UV-Printed Saffiano Texture'], ['rugged', 'Soft TPU Shell Inside'], ['magsafe', 'Magnetic Sleep/Wake Lid']]
  };
  /* MacBook case features. Every string is lifted from the APPROVED launch
     copy spec (single UV-printed front surface on a matte shell, tool-free
     snap-on install, ports and buttons stay reachable) — no drop/impact,
     material-weight or delivery claims, and nothing about the print film
     that the spec attributes to the printable layer rather than the shell.
     Keyed 'default' so the SAME rail serves all five model cards (the
     kindle lesson: never key a rail to renameable option values). */
  var MACBOOK_FEATURES = {
    'default': [['print', 'UV-Printed Matte Finish'], ['magsafe', 'Tool-Free Snap-On Fit'], ['guarantee', 'Ports & Buttons Accessible']]
  };
  function initAmRail(hero, amSel, amCards, featuresMap) {
    var features = featuresMap || AIRPODS_FEATURES;
    var active = amSel.querySelector('.ce-product-hero__visual-card.is-selected') || amCards[0];
    if (!active) return;
    var val = active.getAttribute('data-value') || '';
    /* Per-value rows win; 'default' serves value-agnostic families (kindle).
       rowsKey only picks the ROW SET — the header and the re-render dedupe
       stay keyed on the real card value. */
    var rowsKey = features[val] ? val : (features['default'] ? 'default' : null);
    if (!rowsKey) return;

    var rail = amSel.nextElementSibling;
    if (!rail || !rail.classList.contains('e-tier-rail')) {
      rail = document.createElement('div');
      rail.className = 'e-tier-rail';
      rail.setAttribute('aria-live', 'polite');
      rail.setAttribute('aria-atomic', 'true');
      amSel.insertAdjacentElement('afterend', rail);
    }
    if (rail.__ceTier === val) return;
    rail.__ceTier = val;

    var vd = matVariantDisplay(hero);
    var vCfg = (vd && vd.option1 && vd.option1.values && vd.option1.values[val]) || {};
    var headText = vCfg.name || val;

    var base = elevateAssetBase();
    rail.innerHTML = '';
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = headText + ' includes';
    rail.appendChild(sr);

    var head = document.createElement('div');
    head.className = 'e-tier-rail__head';
    var nm = document.createElement('span');
    nm.className = 'e-tier-rail__name';
    nm.textContent = headText;
    head.appendChild(nm);
    rail.appendChild(head);

    var ul = document.createElement('ul');
    ul.className = 'e-tier-rail__items';
    features[rowsKey].forEach(function (row, ri) {
      var li = document.createElement('li');
      li.style.setProperty('--e-rail-i', ri);
      var icon = document.createElement('img');
      icon.className = 'e-tier-rail__icon';
      icon.src = base + 'icon-usp-' + row[0] + '.png';
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      icon.width = 12;
      icon.height = 12;
      icon.loading = 'lazy';
      li.appendChild(icon);
      var label = document.createElement('span');
      label.className = 'e-tier-rail__label';
      label.textContent = row[1];
      li.appendChild(label);
      ul.appendChild(li);
    });
    rail.appendChild(ul);

    rail.classList.remove('is-in');
    requestAnimationFrame(function () { rail.classList.add('is-in'); });
  }
  function decorateNonCaseOffer() {
    var hero = document.querySelector('.ce-product-hero');
    if (!hero) return;
    if (!hero.querySelector('.ce-product-hero__combined-selector') &&
        !hero.querySelector('.ce-product-hero__individual-selector')) return;
    var h1 = document.querySelector('h1');
    var title = (h1 ? h1.textContent : document.title) || '';
    var noun = nonCaseNoun(title);

    /* under-CTA line: case-style single line, no guarantee. If the
       template's fallback pill still says "Case" on a non-case page,
       name the actual product. */
    hero.querySelectorAll('.ce-product-hero__sub-cta').forEach(function (el) {
      if (el.__ceRewritten) return;
      var m = el.textContent.match(/Get a\s+(.+?)\s*·/);
      if (!m) return;
      el.__ceRewritten = true;
      var offerText = m[1];
      if (noun && /\bcase\b/i.test(offerText)) {
        offerText = offerText.replace(/\bcase\b/ig, titleCaseNoun(noun));
      }
      for (var n = el.lastChild, prev; n; n = prev) {
        prev = n.previousSibling;
        if (n.nodeType === 3) { el.removeChild(n); }
      }
      el.appendChild(document.createTextNode(' ' + offerText + ' — Applied Automatically'));
    });

    /* option-card offer chips -> case-style FREE lockup. The chip text
       comes from admin config (variant_display / bogo pill) that may
       still say "Case" on non-case products — correct the noun here. */
    hero.querySelectorAll('.ce-product-hero__vc-bogo').forEach(function (chip) {
      if (chip.__ceLockup) return;
      var words = chip.textContent.replace(/\s*free\s*$/i, '').trim().toLowerCase().split(/\s+/);
      if (!words.length || !words[0]) return;
      chip.__ceLockup = true;
      var label = words.map(function (w) {
        return /^\d/.test(w) ? w : w.charAt(0).toUpperCase() + w.slice(1);
      }).join(' ');
      if (noun && /\bcase\b/i.test(label)) {
        label = label.replace(/\bcase\b/ig, titleCaseNoun(noun));
      }
      chip.classList.add('e-vc-offer');
      chip.innerHTML = label + ' <b class="e-tier-offer__free">FREE' + SQUIGGLE + '</b>';
    });

    /* CTA joins the case pattern: "Design My Desk Mat · $60" — the
       machinery composes "<cta text> → $60"; swap the arrow join for
       the cases' quiet dot (re-applied after every machinery rewrite) */
    if (noun) {
      hero.querySelectorAll('[id^="ce-product-hero__cta-"]').forEach(function (btn) {
        var t = btn.textContent;
        if (/→\s*\$[\d.,]+\s*$/.test(t)) {
          btn.textContent = t.replace(/\s*→\s*(\$[\d.,]+)(\s*)$/, ' · $1$2');
        }
      });
    }

    /* desk-mat size cards: case-tier-card structure (no photo chip) —
       name / size / price / FREE line; scope class for the skin */
    if (noun === 'desk mat') {
      hero.classList.add('e-mat-hero');
      hero.querySelectorAll('.ce-product-hero__visual-card').forEach(function (card) {
        var nameEl = card.querySelector('.ce-product-hero__vc-name');
        if (nameEl && !nameEl.querySelector('.e-vc-size')) {
          /* split the single frozen value ('XXL Desk Mat (18" x 36")')
             into a bold name line + a smaller size line — the size
             still appears exactly once (the old duplicate sub-line is
             hidden by the skin) */
          var nm = nameEl.textContent.match(/^\s*(.*?)\s*\(([^)]+)\)\s*$/);
          if (nm) {
            nameEl.textContent = nm[1];
            var sz = document.createElement('span');
            sz.className = 'e-vc-size';
            sz.textContent = nm[2];
            nameEl.appendChild(sz);
          }
        }
        var priceEl = card.querySelector('.ce-product-hero__vc-price');
        if (priceEl) {
          /* one variant per size — the exact price, not a "From" hedge */
          priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
          var right = priceEl.parentNode;
          if (right && !right.querySelector('.e-tier-offer')) {
            var offer = document.createElement('div');
            offer.className = 'e-tier-offer';
            offer.appendChild(document.createTextNode('2nd Desk Mat '));
            var free = document.createElement('b');
            free.className = 'e-tier-offer__free';
            free.innerHTML = 'FREE' + SQUIGGLE;
            offer.appendChild(free);
            right.appendChild(offer);
          }
        }
      });
    }

    /* desk-mat Podium Rail (ports the case selector redesign): the four
       per-size feature rows are gone from the cards — three of the four
       were the same string on four of the five sizes, so they cost height
       and taught nothing. The dimensions line on the chip is the one
       honest discriminator; the full feature set lives in ONE rail under
       the grid that rewrites itself for the selected size. Selecting IS
       the disclosure.

       The merchant's variant_display metafield already names the hero
       size (badge "Customer favorite" + "default" on XXL) — honor that
       config: the default card is selected from first paint via a real
       machinery click (individual mode never preselects on its own), so
       the CTA price and the rail agree with state from the start. */
    if (noun === 'desk mat') {
      var matSel = hero.querySelector('.ce-product-hero__individual-selector');
      var matCards = matSel ? matSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (matCards.length) {
        if (!hero.__ceMatDefaulted && !matSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceMatDefaulted = true;
          var mvd = matVariantDisplay(hero);
          var defVal = mvd && mvd.option1 && mvd.option1['default'];
          var defCard = null;
          for (var di = 0; di < matCards.length && !defCard; di++) {
            if (defVal && matCards[di].getAttribute('data-value') === defVal) defCard = matCards[di];
          }
          for (var bi = 0; bi < matCards.length && !defCard; bi++) {
            if (matCards[bi].querySelector('.ce-product-hero__vc-badge')) defCard = matCards[bi];
          }
          /* through the machinery's own click path so variant/state/events
             stay canonical (the click re-runs this decorator via
             ce:state-change; the flag above keeps it single-shot) */
          if (defCard) defCard.click();
        }
        initMatRail(hero, matSel, matCards);
      }
    }

    /* blanket size cards: case-tier-card structure — the machinery's
       plain-card path renders only name + desc, so build the rest:
       price slot, "2nd Blanket FREE" lockup, and the MOST POPULAR
       badge the template configures but the renderer drops. The price
       is the exact variant price for the chosen material (the product
       JSON fetched above); until a material is picked — or for combos
       that don't exist in that material — the slot stays the
       reserved-invisible line, so the card never grows or shifts. */
    if (noun === 'blanket') {
      hero.classList.add('e-blanket-hero');
      fetchNonCaseProduct();
      var selMat = hero.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
      var matVal = selMat ? selMat.getAttribute('data-value') : null;
      var prod = NONCASE_PRODUCT.data;
      hero.querySelectorAll('.ce-product-hero__option-card').forEach(function (card) {
        var val = card.getAttribute('data-value');
        var price = card.querySelector('.ce-oc-price');
        if (!price) {
          price = document.createElement('div');
          price.className = 'ce-oc-price e-oc-price-pending';
          price.innerHTML = '&nbsp;';
          card.appendChild(price);
        }
        if (!card.querySelector('.e-tier-offer')) {
          var offer = document.createElement('div');
          offer.className = 'e-tier-offer';
          offer.appendChild(document.createTextNode('2nd Blanket '));
          var free = document.createElement('b');
          free.className = 'e-tier-offer__free';
          free.innerHTML = 'FREE' + SQUIGGLE;
          offer.appendChild(free);
          card.appendChild(offer);
        }
        if (val && BLANKET_SIZE_BADGES[val] && !card.querySelector('.e-oc-badge')) {
          var badge = document.createElement('span');
          badge.className = 'e-oc-badge';
          badge.textContent = BLANKET_SIZE_BADGES[val];
          card.appendChild(badge);
        }
        var cents = null;
        if (prod && matVal && val) {
          (prod.variants || []).forEach(function (v) {
            if (v.option1 === matVal && v.option2 === val && v.available) cents = v.price;
          });
        }
        if (cents != null) {
          var p = cents / 100;
          price.textContent = '$' + (p % 1 === 0 ? p.toFixed(0) : p.toFixed(2));
          price.classList.remove('e-oc-price-pending');
        } else {
          price.innerHTML = '&nbsp;';
          price.classList.add('e-oc-price-pending');
        }
      });
    }

    /* cutting-board size cards: mat-style card chrome — exact price (one
       variant per size), "2nd Board FREE" lockup, default-select through
       the machinery's own click path, and the feature rail under the
       selector. */
    if (noun === 'cutting board') {
      /* boards borrow the mat's Podium Rail machinery (e-mat-hero) but
         wear the CASE selected-state skin — e-board-hero scopes that
         override so desk mats keep their dark selected card. */
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      var boardSel = hero.querySelector('.ce-product-hero__individual-selector');
      var boardCards = boardSel ? boardSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (boardCards.length) {
        if (!hero.__ceBoardDefaulted && !boardSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceBoardDefaulted = true;
          var bvd = matVariantDisplay(hero);
          var bDefVal = bvd && bvd.option1 && bvd.option1['default'];
          var bDefCard = null;
          for (var bd = 0; bd < boardCards.length && !bDefCard; bd++) {
            if (bDefVal && boardCards[bd].getAttribute('data-value') === bDefVal) bDefCard = boardCards[bd];
          }
          if (!bDefCard) bDefCard = boardCards[0];
          if (bDefCard) bDefCard.click();
        }
        /* one valid size per shape: sync the Size step to the chosen shape
           through the machinery's own click path (value-idempotent, so the
           ce:state-change re-run settles instead of looping). The Size cards
           stay visible as the dimensions disclosure. */
        fetchNonCaseProduct();
        var selShapeCard = boardSel.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
        var selShapeVal = selShapeCard && selShapeCard.getAttribute('data-value');
        var boardProd = NONCASE_PRODUCT.data;
        if (selShapeVal && boardProd) {
          var validSizes = [];
          (boardProd.variants || []).forEach(function (v) {
            if (v.option1 === selShapeVal && v.available !== false && validSizes.indexOf(v.option2) === -1) validSizes.push(v.option2);
          });
          if (validSizes.length) {
            /* auto-select only when the current size is missing or invalid
               for the shape — a shape with several sizes (Rectangle 8x11 /
               11x15) keeps the user's manual size choice */
            var selectedSize = null;
            var sizeCardByValue = {};
            boardSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
              var val = card.getAttribute('data-value');
              sizeCardByValue[val] = card;
              if (card.classList.contains('is-selected')) selectedSize = val;
            });
            if ((!selectedSize || validSizes.indexOf(selectedSize) === -1) && sizeCardByValue[validSizes[0]]) {
              sizeCardByValue[validSizes[0]].click();
            }
          }
        }
        boardCards.forEach(function (card) {
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            /* exact price only for single-size shapes — a shape with two
               sizes keeps its honest "From $X" hedge */
            var cardShape = card.getAttribute('data-value');
            var cardSizeCount = 0;
            if (NONCASE_PRODUCT.data) {
              (NONCASE_PRODUCT.data.variants || []).forEach(function (v) {
                if (v.option1 === cardShape && v.available !== false) cardSizeCount++;
              });
            }
            if (cardSizeCount === 1) {
              priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
            }
            var right = priceEl.parentNode;
            if (right && !right.querySelector('.e-tier-offer')) {
              var offer = document.createElement('div');
              offer.className = 'e-tier-offer';
              offer.appendChild(document.createTextNode('2nd Board '));
              var free = document.createElement('b');
              free.className = 'e-tier-offer__free';
              free.innerHTML = 'FREE' + SQUIGGLE;
              offer.appendChild(free);
              right.appendChild(offer);
            }
          }
        });
        initBoardRail(hero, boardSel, boardCards);
      }
    }

    /* rug style cards: same Podium Rail machinery + the case-style white
       selected skin as boards. Sparse Style x Size matrix (Round has ONE
       size, Outdoor four, Area six): picking a style syncs the Size step
       to that style's first valid size through the machinery's own click
       path, so no style card is ever a dead end. Offer chip is the
       truthful "Free Shipping" (the rug family is single-unit only —
       never a BOGO lockup). */
    if (noun === 'rug') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-rug-hero');
      var rugSel = hero.querySelector('.ce-product-hero__individual-selector');
      var rugCards = rugSel ? rugSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (rugCards.length) {
        if (!hero.__ceRugDefaulted && !rugSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceRugDefaulted = true;
          var rvd = matVariantDisplay(hero);
          var rDefVal = rvd && rvd.option1 && rvd.option1['default'];
          var rDefCard = null;
          for (var rd = 0; rd < rugCards.length && !rDefCard; rd++) {
            if (rDefVal && rugCards[rd].getAttribute('data-value') === rDefVal) rDefCard = rugCards[rd];
          }
          if (!rDefCard) rDefCard = rugCards[0];
          if (rDefCard) rDefCard.click();
        }
        /* sync the Size step to the chosen style (value-idempotent, so the
           ce:state-change re-run settles instead of looping) */
        fetchNonCaseProduct();
        var selStyleCard = rugSel.querySelector('.ce-product-hero__visual-card.is-selected[data-option-key="option1"]');
        var selStyleVal = selStyleCard && selStyleCard.getAttribute('data-value');
        var rugProd = NONCASE_PRODUCT.data;
        if (selStyleVal && rugProd) {
          var rugValidSizes = [];
          (rugProd.variants || []).forEach(function (v) {
            if (v.option1 === selStyleVal && v.available !== false && rugValidSizes.indexOf(v.option2) === -1) rugValidSizes.push(v.option2);
          });
          if (rugValidSizes.length) {
            var rugSelectedSize = null;
            var rugSizeCardByValue = {};
            rugSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
              var val = card.getAttribute('data-value');
              rugSizeCardByValue[val] = card;
              if (card.classList.contains('is-selected')) rugSelectedSize = val;
            });
            if ((!rugSelectedSize || rugValidSizes.indexOf(rugSelectedSize) === -1) && rugSizeCardByValue[rugValidSizes[0]]) {
              rugSizeCardByValue[rugValidSizes[0]].click();
            }
          }
        }
        /* per-size exact price under the dimensions line — the exact
           variant price for the chosen style (the product JSON fetched
           above). Until the style resolves, or for sizes the sparse
           matrix doesn't sell in that style, the slot stays the
           reserved-invisible line so the card never grows or shifts. */
        rugSel.querySelectorAll('.ce-product-hero__option-card[data-option-key="option2"]').forEach(function (card) {
          var sizeVal = card.getAttribute('data-value');
          var sizePrice = card.querySelector('.ce-oc-price');
          if (!sizePrice) {
            sizePrice = document.createElement('div');
            sizePrice.className = 'ce-oc-price e-oc-price-pending';
            sizePrice.innerHTML = '&nbsp;';
            card.appendChild(sizePrice);
          }
          var rugCents = null;
          if (rugProd && selStyleVal && sizeVal) {
            (rugProd.variants || []).forEach(function (v) {
              if (v.option1 === selStyleVal && v.option2 === sizeVal && v.available !== false) rugCents = v.price;
            });
          }
          if (rugCents != null) {
            var rp = rugCents / 100;
            sizePrice.textContent = '$' + (rp % 1 === 0 ? rp.toFixed(0) : rp.toFixed(2));
            sizePrice.classList.remove('e-oc-price-pending');
          } else {
            sizePrice.innerHTML = '&nbsp;';
            sizePrice.classList.add('e-oc-price-pending');
          }
        });
        rugCards.forEach(function (card) {
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            var cardStyle = card.getAttribute('data-value');
            var cardSizes = 0;
            if (NONCASE_PRODUCT.data) {
              (NONCASE_PRODUCT.data.variants || []).forEach(function (v) {
                if (v.option1 === cardStyle && v.available !== false) cardSizes++;
              });
            }
            if (cardSizes === 1) {
              priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
            }
            var right = priceEl.parentNode;
            if (right && !right.querySelector('.e-tier-offer')) {
              var offer = document.createElement('div');
              offer.className = 'e-tier-offer';
              offer.appendChild(document.createTextNode('Free '));
              var ship = document.createElement('b');
              ship.className = 'e-tier-offer__free';
              ship.innerHTML = 'Shipping' + SQUIGGLE;
              offer.appendChild(ship);
              right.appendChild(offer);
            }
          }
        });
        initRugRail(hero, rugSel, rugCards);
      }
    }

    /* airpods max case: ONE style card. Same white selected skin as
       boards/rugs; default-select the single card so the CTA is never stuck
       on "Choose Style to Continue" (found on the 2026-07-26 draft PDP
       render); card is titled with the SUPPORTED MODELS from
       variant_display (founder direction 2026-07-27: name the models, not
       "Custom"); features rail above the CTA. NO offer chip: the product
       does not free-ship (store threshold is $65; founder correction
       2026-07-27) and the family is single-unit only. */
    if (noun === 'airpods max case') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      var amSel = hero.querySelector('.ce-product-hero__individual-selector');
      var amCards = amSel ? amSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (amCards.length) {
        var avd = matVariantDisplay(hero);
        if (!hero.__ceAmDefaulted && !amSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceAmDefaulted = true;
          var aDefVal = avd && avd.option1 && avd.option1['default'];
          var aDefCard = null;
          for (var ad = 0; ad < amCards.length && !aDefCard; ad++) {
            if (aDefVal && amCards[ad].getAttribute('data-value') === aDefVal) aDefCard = amCards[ad];
          }
          if (!aDefCard) aDefCard = amCards[0];
          if (aDefCard) aDefCard.click();
        }
        amCards.forEach(function (card) {
          /* Card title: the variant_display name ("AirPods Max 1st / 2nd
             Gen") instead of the raw option value "Custom" — the plain
             visual_card renderer ignores the configured name. */
          var aVal = card.getAttribute('data-value') || '';
          var aCfg = (avd && avd.option1 && avd.option1.values && avd.option1.values[aVal]) || {};
          var aNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (aNameEl && aCfg.name && aNameEl.textContent !== aCfg.name) {
            aNameEl.textContent = aCfg.name;
          }
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
          }
        });
        initAmRail(hero, amSel, amCards);
      }
    }

    /* kindle case: same single-card shape as the airpods max case — ONE
       style card default-selected so the CTA is never stuck on "Choose
       Style to Continue"; card titled with the SUPPORTED MODELS from
       variant_display; features rail above the CTA. NO offer chip: $40 is
       under the store's $65 free-shipping threshold and the family is
       single-unit only. */
    if (noun === 'kindle case') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      /* Kindle-scoped skin: centers the model-card grid and un-hides the
         per-model fit line the mat skin suppresses (founder direction
         2026-07-28: make what each case supports obvious on the card). */
      hero.classList.add('e-kindle-hero');
      var kSel = hero.querySelector('.ce-product-hero__individual-selector');
      var kCards = kSel ? kSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (kCards.length) {
        var kvd = matVariantDisplay(hero);
        if (!hero.__ceKindleDefaulted && !kSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceKindleDefaulted = true;
          var kDefVal = kvd && kvd.option1 && kvd.option1['default'];
          var kDefCard = null;
          for (var kd = 0; kd < kCards.length && !kDefCard; kd++) {
            if (kDefVal && kCards[kd].getAttribute('data-value') === kDefVal) kDefCard = kCards[kd];
          }
          if (!kDefCard) kDefCard = kCards[0];
          if (kDefCard) kDefCard.click();
        }
        kCards.forEach(function (card) {
          /* Card title: the variant_display name (the short model name)
             instead of the raw option value; the fit line under it comes
             from the variant_display desc — injected here because the
             machinery does not always render vc-desc for visual cards. */
          var kVal = card.getAttribute('data-value') || '';
          var kCfg = (kvd && kvd.option1 && kvd.option1.values && kvd.option1.values[kVal]) || {};
          var kNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (kNameEl && kCfg.name && kNameEl.textContent !== kCfg.name) {
            kNameEl.textContent = kCfg.name;
          }
          if (kCfg.desc) {
            var kDescEl = card.querySelector('.ce-product-hero__vc-desc');
            if (!kDescEl) {
              kDescEl = document.createElement('div');
              kDescEl.className = 'ce-product-hero__vc-desc';
              if (kNameEl) kNameEl.insertAdjacentElement('afterend', kDescEl);
              else card.appendChild(kDescEl);
            }
            if (kDescEl.textContent !== kCfg.desc) kDescEl.textContent = kCfg.desc;
          }
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
          }
        });
        initAmRail(hero, kSel, kCards, KINDLE_FEATURES);
      }
    }

    /* macbook case: the kindle shape with FIVE model cards. Same board-hero
       selected-state skin, same default-selection (so the CTA is never stuck
       on "Choose Style to Continue"), same vc-desc injection for the fit line
       the mat skin hides. NO offer chip: $59 is under the store's $65
       free-shipping threshold and the family is single-unit, no BOGO. */
    if (noun === 'macbook case') {
      hero.classList.add('e-mat-hero');
      hero.classList.add('e-board-hero');
      hero.classList.add('e-am-hero');
      /* MacBook-scoped skin: 5 cards wrap 3+2, so the grid becomes a
         CENTERED flex wrap (a 3-col grid would leave the second row
         ragged-left) and the per-model fit line is un-hidden. */
      hero.classList.add('e-macbook-hero');
      var mSel = hero.querySelector('.ce-product-hero__individual-selector');
      var mCards = mSel ? mSel.querySelectorAll('.ce-product-hero__visual-card[data-option-key="option1"]') : [];
      if (mCards.length) {
        var mvd = matVariantDisplay(hero);
        if (!hero.__ceMacbookDefaulted && !mSel.querySelector('.ce-product-hero__visual-card.is-selected')) {
          hero.__ceMacbookDefaulted = true;
          var mDefVal = mvd && mvd.option1 && mvd.option1['default'];
          var mDefCard = null;
          for (var md = 0; md < mCards.length && !mDefCard; md++) {
            if (mDefVal && mCards[md].getAttribute('data-value') === mDefVal) mDefCard = mCards[md];
          }
          if (!mDefCard) mDefCard = mCards[0];
          if (mDefCard) mDefCard.click();
        }
        mCards.forEach(function (card) {
          /* Card title: the variant_display name (the short model name);
             the supported-sizes line under it comes from the desc —
             injected here because the machinery does not render vc-desc
             for visual cards. */
          var mVal = card.getAttribute('data-value') || '';
          var mCfg = (mvd && mvd.option1 && mvd.option1.values && mvd.option1.values[mVal]) || {};
          var mNameEl = card.querySelector('.ce-product-hero__vc-name');
          if (mNameEl && mCfg.name && mNameEl.textContent !== mCfg.name) {
            mNameEl.textContent = mCfg.name;
          }
          if (mCfg.desc) {
            var mDescEl = card.querySelector('.ce-product-hero__vc-desc');
            if (!mDescEl) {
              mDescEl = document.createElement('div');
              mDescEl.className = 'ce-product-hero__vc-desc';
              if (mNameEl) mNameEl.insertAdjacentElement('afterend', mDescEl);
              else card.appendChild(mDescEl);
            }
            if (mDescEl.textContent !== mCfg.desc) mDescEl.textContent = mCfg.desc;
          }
          var priceEl = card.querySelector('.ce-product-hero__vc-price');
          if (priceEl) {
            priceEl.textContent = priceEl.textContent.replace(/^\s*From\s+/i, '');
          }
        });
        initAmRail(hero, mSel, mCards, MACBOOK_FEATURES);
      }
    }

    /* option-card price slot: reserve the height from first render so
       the machinery's re-render (which adds .ce-oc-price once a prior
       option is picked) can't grow the card and shift the page. Grids
       that never receive a price just keep an invisible line — equal
       card heights either way. */
    hero.querySelectorAll('.ce-product-hero__option-card').forEach(function (card) {
      if (card.querySelector('.ce-oc-price')) return;
      var ph = document.createElement('div');
      ph.className = 'ce-oc-price e-oc-price-pending';
      ph.innerHTML = '&nbsp;';
      card.appendChild(ph);
    });
  }
  function elevateAssetBase() {
    if (window.ceElevateAssetBase) return window.ceElevateAssetBase;
    var s = document.querySelector('script[src*="ce-elevate.js"]');
    return s ? s.src.split('ce-elevate.js')[0] : '';
  }
  function tierCardName(card) {
    var el = card.querySelector('.ce-product-hero__tier-card-name');
    return el ? el.textContent.trim() : '';
  }

  /* Only decorate where the elevate PDP skin is actually loaded. It ships
     via ce-keepsake-pdp-skin (which renders .ce-keepsake-section);
     ce-noncustom-hero is a class-identical clone that loads no skin, so
     without this gate its cards would sprout an unstyled rail. */
  function tierSkinOn() {
    return !!document.querySelector('.ce-keepsake-section');
  }

  /* Find the recommended (badged) card in a wrap, or null. */
  function recommendedCard(wrap) {
    var cards = wrap.querySelectorAll('.ce-product-hero__tier-card');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].querySelector('.ce-product-hero__tier-card-badge')) return cards[i];
    }
    return null;
  }

  /* Chip: wrap the photo so the drop pill can ride inside it. */
  function initTierChips() {
    if (!tierSkinOn()) return;
    document.querySelectorAll('.ce-product-hero__tier-wrap').forEach(function (wrap) {
      /* Show the recommended style as selected by default. The machinery
         only marks a card .active once a phone model is chosen (preselect
         fires in setModel), so before that nothing reads as picked. When
         no card is active yet, default the selection to the recommended
         card — the same card preselect resolves to, so the two never
         disagree and this yields to the real selection the moment it lands. */
      if (!wrap.querySelector('.ce-product-hero__tier-card.active')) {
        var rec = recommendedCard(wrap);
        if (rec) rec.classList.add('active');
      }
      wrap.querySelectorAll('.ce-product-hero__tier-card').forEach(function (card) {
        /* the machinery sets role/tabindex/aria-label but never says which
           card is chosen */
        card.setAttribute('aria-pressed', card.classList.contains('active') ? 'true' : 'false');
        if (card.querySelector('.e-tier-shot')) return;
        var img = card.querySelector('.ce-product-hero__tier-card-img');
        if (!img) return;
        var shot = document.createElement('div');
        shot.className = 'e-tier-shot';
        img.parentNode.insertBefore(shot, img);
        shot.appendChild(img);
        var spec = TIER_SPEC[tierCardName(card)];
        if (!spec) return;
        var pill = document.createElement('span');
        pill.className = 'e-tier-drop';
        pill.textContent = spec.drop;
        shot.appendChild(pill);
      });
    });
  }

  /* One rail per selector, inserted OUTSIDE the grid the machinery wipes
     (renderCaseTypes does tierGrid.innerHTML = ''), so it is created once
     and only ever has its contents rewritten. */
  function initTierRail() {
    if (!tierSkinOn()) return;
    document.querySelectorAll('.ce-product-hero__tier-wrap').forEach(function (wrap) {
      var cards = wrap.querySelectorAll('.ce-product-hero__tier-card');
      if (!cards.length) return;

      /* Before a model is picked nothing is .active — fall back to the
         recommended card so the rail is populated from first paint and
         never shifts when the preselect lands. */
      var active = wrap.querySelector('.ce-product-hero__tier-card.active');
      if (!active) {
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].querySelector('.ce-product-hero__tier-card-badge')) { active = cards[i]; break; }
        }
      }
      if (!active) active = cards[0];

      var name = tierCardName(active);
      var spec = TIER_SPEC[name];
      if (!spec) return; /* non-case hero (mats, blankets) — leave alone */

      var rail = wrap.nextElementSibling;
      if (!rail || !rail.classList.contains('e-tier-rail')) {
        rail = document.createElement('div');
        rail.className = 'e-tier-rail';
        rail.setAttribute('aria-live', 'polite');
        rail.setAttribute('aria-atomic', 'true');
        wrap.insertAdjacentElement('afterend', rail);
      }
      /* the retry ladder + every state change call this; without the guard
         the rail would re-animate on each no-op pass */
      if (rail.__ceTier === name) return;
      rail.__ceTier = name;

      var base = elevateAssetBase();
      rail.innerHTML = '';

      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      sr.textContent = name + ' includes';
      rail.appendChild(sr);

      var head = document.createElement('div');
      head.className = 'e-tier-rail__head';
      var nm = document.createElement('span');
      nm.className = 'e-tier-rail__name';
      nm.textContent = name;
      head.appendChild(nm);
      var spectrum = document.querySelector('.ce-protection');
      if (spectrum) {
        var cmp = document.createElement('button');
        cmp.type = 'button';
        cmp.className = 'e-tier-rail__compare';
        cmp.textContent = 'Compare all styles →';
        cmp.addEventListener('click', function () {
          spectrum.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        head.appendChild(cmp);
      }
      rail.appendChild(head);

      var ul = document.createElement('ul');
      ul.className = 'e-tier-rail__items';
      spec.rows.forEach(function (row, i) {
        var li = document.createElement('li');
        li.style.setProperty('--e-rail-i', i);
        var icon = document.createElement('img');
        icon.className = 'e-tier-rail__icon';
        icon.src = base + 'icon-usp-' + row[0] + '.png';
        icon.alt = '';
        icon.setAttribute('aria-hidden', 'true');
        icon.width = 12;
        icon.height = 12;
        icon.loading = 'lazy';
        li.appendChild(icon);
        var label = document.createElement('span');
        label.className = 'e-tier-rail__label';
        label.textContent = row[1];
        li.appendChild(label);
        ul.appendChild(li);
      });
      rail.appendChild(ul);

      /* animate in only — fading out first would cost a round-trip and
         read as lag on tap */
      rail.classList.remove('is-in');
      requestAnimationFrame(function () { rail.classList.add('is-in'); });
    });
  }

  /* Arm once: note that the pending select came from the keyboard. Never
     calls preventDefault/stopPropagation, so it cannot swallow the
     machinery's own activation. */
  function initTierRestore() {
    document.querySelectorAll('.ce-product-hero__tier-wrap').forEach(function (wrap) {
      if (wrap.__ceRestoreArmed) return;
      wrap.__ceRestoreArmed = true;
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { wrap.__ceKbd = true; }
      }, true);
    });
  }

  /* Repair what the innerHTML wipe destroys on every select:
     - scrollLeft collapses to 0, so tapping tier 4 scrolls your own pick
       off screen (only visible once the row actually overflows)
     - the focused card is deleted, dropping focus to <body> (a WCAG fail) */
  function restoreTierState() {
    document.querySelectorAll('.ce-product-hero__tier-wrap').forEach(function (wrap) {
      var grid = wrap.querySelector('.ce-product-hero__tier-grid');
      var active = wrap.querySelector('.ce-product-hero__tier-card.active');
      if (!grid || !active) return;
      if (grid.scrollWidth > grid.clientWidth + 8) {
        active.scrollIntoView({ inline: 'nearest', block: 'nearest' });
      }
      if (wrap.__ceKbd) {
        wrap.__ceKbd = false;
        try { active.focus(); } catch (e) { /* node may be gone */ }
      }
    });
  }

  function init() {
    initAccents();
    initCtaPriceSuffix();
    initStickyPromoGuard();
    initReveals();
    initHeroStagger();
    injectSticker();
    initCountUp();
    initProofCycle();
    /* client-rendered PDP labels + tier cards: retry briefly + follow
       machinery events (the selector re-renders cards on brand switch) */
    [600, 1500, 3200].forEach(function (ms) {
      setTimeout(function () {
        initStepNums(); initTierChips(); initTierRail(); initTierRestore();
        decorateFreePricing(); decorateNonCaseOffer();
      }, ms);
    });
    document.addEventListener('ce:state-change', function () {
      initStepNums(); initTierChips(); initTierRail(); initTierRestore();
      restoreTierState(); decorateFreePricing(); decorateNonCaseOffer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: sections re-render — reveal everything, re-run idempotent bits */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.e-reveal-auto, .k-reveal, .e-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
    initAccents();
  });
})();
